import { Component } from "@angular/core";

@Component({
  selector: "no-content",
  templateUrl: "no-content.template.html"
})
export class NoContentComponent {

}
